var gridTranslations = function gridTranslations(translate) {
  return {
    // PagingPanel Translations
    showAll: translate('rgrd:showAll'),
    rowsPerPage: translate('rgrd:rowsPerPage', ['Rows per page']),
    info: translate('rgrd:info', ['{from}-{to} of {count}']),
    // tableColumnVisibility Translations
    noColumns: translate('rgrd:noColumns'),
    // TableFilterRow Translations
    filterPlaceholder: translate('rgrd:filterPlaceholder'),
    contains: translate('rgrd:contains'),
    notContains: translate('rgrd:notContains'),
    startsWith: translate('rgrd:startsWith'),
    endsWith: translate('rgrd:endsWith'),
    equal: translate('rgrd:equal'),
    notEqual: translate('rgrd:notEqual'),
    greaterThan: translate('rgrd:greaterThan'),
    greaterThanOrEqual: translate('rgrd:greaterThanOrEqual'),
    lessThan: translate('rgrd:lessThan'),
    lessThanOrEqual: translate('rgrd:lessThanOrEqual'),
    empty: translate('rgrd:empty'),
    notEmpty: translate('rgrd:notEmpty'),
    // Check grid column filter translations
    all: translate('rgrd:showAll'),
    // Re-using the paging translation from above for the text "All"
    active: translate('cmmn:active'),
    inactive: translate('cmmn:inactive'),
    // TableHeaderRowFilter Plugin Translations
    filter: translate('rgrd:filter'),
    columnFilterLabel: translate('rgrd:columnFilterLabel'),
    clear: translate('cmmn:clear'),
    apply: translate('cmmn:apply'),
    dateTimeFilterStart: translate('rgrd:dateTimeFilterStart'),
    dateTimeFilterEnd: translate('rgrd:dateTimeFilterEnd'),
    dateFilterLabel: translate('rgrd:dateFilterLabel'),
    timeFilterLabel: translate('rgrd:timeFilterLabel'),
    // Invalid date filter error messages
    startDateAfterEndDateError: translate('rgrd:startDateAfterEndDateError'),
    endDateBeforeStartDateError: translate('rgrd:endDateBeforeStartDateError'),
    startTimeAfterEndTimeError: translate('rgrd:startTimeAfterEndTimeError'),
    endTimeBeforeStartTimeError: translate('rgrd:endTimeBeforeStartTimeError'),
    // ToolbarClearFiltersPlugin Translations
    clearFilters: translate('rgrd:clearFilters'),
    // ColumnChooser Translations
    showColumnChooser: translate('rgrd:showColumnChooser'),
    // Table Plugin
    noData: translate('rgrd:noData'),
    // TableHeaderRow
    sortingHint: translate('rgrd:sortingHint'),
    // Group Panel
    groupByColumn: translate('rgrd:groupByColumn'),
    // TableGroupRow
    groupIconExpandLabel: translate('cmmn:expand'),
    groupIconCollapseLabel: translate('cmmn:collapse'),
    // Actions Translations
    actionHeader: translate('rgrd:actionHeader'),
    // Button Translations
    emailButton: translate('rgrd:emailButton'),
    addNewButton: translate('rgrd:addNewButton'),
    filterToggleButton: translate('rgrd:filterToggleButton'),
    deleteButton: translate('rgrd:deleteButton')
  };
};

export { gridTranslations };